export default {
    MASCULINO: 1,
    FEMININO: 2,
}
